//
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './router';
import vuetify from './vuetify/vuetify';
import { i18n } from './i18n/i18n';

import { useGlobalStore } from './stores/global/global.store';

import { capacitorPlugin } from '@/plugins/capacitorPlugin';
import { dynatracePlugin, type IDynatraceClient } from '@/plugins/dynatracePlugin';
import { axiosPlugin } from '@/plugins/axiosPlugin';
import Auth, { authPlugin } from './plugins/auth';
import { vueErrorHandler } from './errorHandlers/vueErrorHandler';
import { vaultErrorHandler } from './errorHandlers/vaultErrorHandler';

declare module 'vue' {
  interface ComponentCustomProperties {
    $dynatrace: IDynatraceClient;
    $auth: typeof Auth;
  }
}

const startApp = async () => {
  await Auth.initialize(); // ? initialize auth plugin

  const app = createApp(App);

  app.config.errorHandler = vueErrorHandler;

  app.use(capacitorPlugin);
  app.use(dynatracePlugin);
  app.use(authPlugin);
  app.use(axiosPlugin);
  app.use(vuetify);
  app.use(createPinia());
  app.use(router);
  app.use(i18n);

  const globalStore = useGlobalStore();
  await globalStore.buildUserSessionMetaInfo(); // ? build session/device meta info
  Auth.config.setVaultErrorHandler(vaultErrorHandler);

  await router.isReady(); // ? wait for router to be ready
  app.mount('#app');
};

await startApp();
